import { ArrowDownIcon } from '@phosphor-icons/react'
import { Button } from 'app/components/ui/button'
import { cn } from 'app/lib/utils'

type MoveHereButtonProps = {
  onClick: () => void
  className?: string
  style?: React.CSSProperties
}

export function MoveHereButton({ onClick, className, style }: MoveHereButtonProps) {
  return (
    <Button
      variant="primary"
      size="xs"
      shape="pill"
      style={style}
      onClick={(e) => {
        e.stopPropagation()
        onClick()
      }}
      className={cn(`nodrag nopan h-6 gap-1 px-2.5 text-[11px] shadow-md animate-in fade-in zoom-in-95`, className)}
    >
      <ArrowDownIcon size={11} weight="bold" />
      Move here
    </Button>
  )
}
